import type { ReactNode } from 'react';

export const symbol_signal_cellular_alt_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M464.5-174.58Q450-189.17 450-210v-214L82-792q-9-9.07-9-21.53Q73-826 82.05-835q9.06-9 21.5-9 12.45 0 21.45 9l710 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83L550-324v114q0 20.83-14.62 35.42Q520.76-160 499.88-160q-20.88 0-35.38-14.58ZM750-317q-19 0-34.5-13T700-367v-383q0-20.83 14.62-35.42Q729.24-800 750.12-800q20.88 0 35.38 14.58Q800-770.83 800-750v384q0 26-15.5 37.5T750-317Zm-464.5-68.42Q300-370.83 300-350v140q0 20.83-14.62 35.42Q270.76-160 249.88-160q-20.88 0-35.38-14.58Q200-189.17 200-210v-140q0-20.83 14.62-35.42Q229.24-400 250.12-400q20.88 0 35.38 14.58Z"
		/>
	</svg>
);
